import { BlogArticle } from '@shared/models/blog-article.model';
import { Component, Input } from '@angular/core';
import { TrackingService } from '@core/services';
import { environment } from '@env/environment';

@Component({
    selector: 'gh-carousel',
    templateUrl: 'carousel.component.html',
    standalone: false
})

export class CarouselComponent {
  @Input() articles: BlogArticle[];

  constructor(
    private trackingService: TrackingService,
  ) { }

  navClick(postName: string, location: string) {
    this.trackingService.setDataLayerAttributes({
      event: 'interactionEvent',
      event_name: 'popular_stories_click',
      events: {
        post_name: postName,
        feature: 'blog',
        environment: environment.env,
        location
      }
    });
  }
}
